import { IStore } from '@/store/types';
import { IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  detail: { data: null, loading: false },
  thumb: { data: null, loading: false },
  envLight: { data: null, loading: false },
  invalidRooms: { data: [], loading: false },
  clearLogs: { data: [], pageNum: 0, pageSize: 0, total: 0, loading: false },
  specifics: { data: [], loading: false },
  specificDialog: { type: '', visible: false, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  search: { pageNum: 1, pageSize: 10 },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
